// extracted by mini-css-extract-plugin
export default {"BurgerNav":"BurgerNav_BurgerNav__QhbTP","BurgerNav__Links":"BurgerNav_BurgerNav__Links__eICjK"};